import './TablePage.scss';
import cn from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import { BPMTableWidget } from '../BPMTableWidget';
import { Background, BackgroundType } from '../designConstants';

interface TablePageProps extends PropsWithChildren {
  className?: string;
  dataTestId?: string;
  widgetClassName?: string;
  tableClassName?: string;
  background?: BackgroundType;
  fillHeight?: boolean;
  header?: ReactNode;
  rightActions?: ReactNode;
}

// The canonical "one big table" page shape: a page-level flex/padding chain wrapping a single
// BPMTableWidget. Pages whose layout is more than one table (e.g. two side-by-side tables) should
// compose BPMTableWidget directly inside their own outer wrapper instead of this.
export const TablePage = ({
  className,
  dataTestId,
  widgetClassName,
  tableClassName,
  background = Background.DARK,
  fillHeight,
  header,
  rightActions,
  children
}: TablePageProps) => (
  <div className={cn('table-page', className)} data-testid={dataTestId}>
    <BPMTableWidget
      className={widgetClassName}
      tableClassName={tableClassName}
      background={background}
      fillHeight={fillHeight}
      header={header}
      rightActions={rightActions}
    >
      {children}
    </BPMTableWidget>
  </div>
);
